
declare var latte: any;

export class RecommenderWidget {

    public static init() {
        var options = {
            count: 3,
            move: 1,
            touch: true,
            mode: "align",
            buttons: false,
            dots: true,
            rewind: true,
            autoplay: 0,
            animation: 500,
            responsive: {
                "0": { count: 1 },
                "689": { count: 2},
                "1024": { count: 3, dots: false},
                
            },
        };
        var carousel = new latte.Carousel("#carousel", options);
    }

}